"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockBush = void 0;
const rbush_1 = __importDefault(require("rbush"));
const ltentity_1 = require("../cad/ltentity");
const ltpoint_1 = require("../cad/ltpoint");
const ltutils_1 = require("./ltutils");
//用于解决捕捉效率问题,优先块很大;
class BlockBush {
    constructor(block) {
        this._block = block;
        this._rbush = new rbush_1.default();
    }
    updateBush() {
        //获取所有的;
        let result_items = [];
        let _updateBush = (ent) => {
            //做两层分解，第三层暂时不做分解,不分解就直接调用块内部的方法，影响不大了；
            let pos = ent.subData().position;
            let scale_factors = ent.subData().scaleFactors;
            let block_reference = window.cadmap.dwgservice.getBlock(ent.blockName);
            if (block_reference == null) {
                return false;
            }
            for (let sub_ent of block_reference._entitys) {
                let clone_ent = sub_ent.clone();
                clone_ent.move(pos);
                clone_ent.scale(scale_factors, pos);
                let box = clone_ent.getBoundingBox();
                let min_point = box.getMinimum();
                let max_point = box.getMaximum();
                let shape_item = { minX: min_point.x, minY: min_point.y, maxX: max_point.x, maxY: max_point.y, entity: clone_ent };
                result_items.push(shape_item);
            }
            return true;
        };
        for (let entity of this._block._entitys) {
            if (entity instanceof ltentity_1.LTEntityPoint) {
                if (_updateBush(entity)) {
                    continue;
                }
            }
            let box = entity.getBoundingBox();
            let min_point = box.getMinimum();
            let max_point = box.getMaximum();
            let shape_item = { minX: min_point.x, minY: min_point.y, maxX: max_point.x, maxY: max_point.y, entity: entity };
            result_items.push(shape_item);
        }
        this._rbush.load(result_items);
    }
    getEntitys(ent, bounds) {
        if (!(ent instanceof ltentity_1.LTEntityPoint)) {
            return [];
        }
        let clone_box = bounds.clone();
        let pos = ent.subData().position;
        let scale_factors = ent.subData().scaleFactors;
        let rotate = ent.subData().getRotate();
        clone_box.move(new ltpoint_1.LTPoint(-pos.x, -pos.y));
        if (Math.abs(rotate) > 1e-4) {
            //进行旋转,在获取外包;
            let polyline = ltutils_1.LTUtils.boxToPolyline(clone_box);
            polyline.rotate(-rotate, new ltpoint_1.LTPoint(0, 0));
            clone_box = polyline.getBoundingBox();
        }
        clone_box.scale(new ltpoint_1.LTPoint(1.0 / scale_factors.x, 1.0 / scale_factors.y), null);
        //根据scale扩充范围;
        let entitys = this._rbush.search({ minX: clone_box.getMinimum().x,
            minY: clone_box.getMinimum().y,
            maxX: clone_box.getMaximum().x,
            maxY: clone_box.getMaximum().y });
        let result_entities = [];
        for (let sub_ent of entitys) {
            //坐标需要还原到真实的数据坐标;
            let clone_ent = sub_ent.entity.clone();
            clone_ent.move(pos);
            if (Math.abs(rotate) > 1e-4) {
                clone_ent.rotate(rotate, pos);
            }
            clone_ent.scale(scale_factors, pos);
            result_entities.push(clone_ent);
        }
        return result_entities;
    }
    getEntitys2(ent, bounds, callback) {
        let entitys = this.getEntitys(ent, bounds);
        let result_entities = [];
        for (let sub_ent of entitys) {
            if (callback(sub_ent)) {
                result_entities.push(sub_ent);
            }
        }
        return result_entities;
    }
}
exports.BlockBush = BlockBush;
